import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';
import moment from 'moment';
import { UncontrolledTooltip } from 'reactstrap';
import { connect } from 'react-redux';

import { buttonsV2 as Buttons } from '@breezeway/brzw-components';
import datastore from '@datastore';
import AssignmentBadge from '../../badges/assignment_badge/v2';
import Avatar from '../../avatar';
import { PERIODS, TASK_ASSIGNMENT_STATUS } from '../../../utils/task';
import { personName } from '../../../utils/people_helpers';

import './assignment_preview_row.scss';

const CLASS_NAME = 'assignment_preview_row';

export class AssignmentPreviewRow extends PureComponent {
  constructor(props) {
    super(props);

    this.getExpiresAt = this.getExpiresAt.bind(this);
    this.getExpireTimeText = this.getExpireTimeText.bind(this);
    this.removeAssignment = this.removeAssignment.bind(this);
    this.shouldRenderExpireAtInfo = this.shouldRenderExpireAtInfo.bind(this);
  }

  getExpiresAt() {
    return _.get(this.props.assignment, 'expires_at');
  }

  getExpireTimeText() {
    const { periodSetting } = this.props;
    const duration = moment.duration(moment.utc(this.getExpiresAt()).diff(moment.utc()));

    return periodSetting === PERIODS.HOURS
      ? ` ${Math.floor(duration.asHours())}h`
      : ` ${Math.floor(duration.asMinutes())}m`;
  }

  shouldRenderExpireAtInfo() {
    const { assignment } = this.props;
    const expiresAt = _.get(assignment, 'expires_at');
    return (
      _.get(assignment, 'type_task_user_status.code') === TASK_ASSIGNMENT_STATUS.PENDING &&
      expiresAt &&
      moment.utc() < moment.utc(expiresAt)
    );
  }

  removeAssignment(id, person) {
    const { removePerson } = this.props;

    return () => {
      removePerson(id, person);
    };
  }

  render() {
    const { assignment, editMode, personId, getPersonFromId } = this.props;
    const person = getPersonFromId(personId);
    const shouldShowExpireInfo = this.shouldRenderExpireAtInfo();
    const expireTimeText = shouldShowExpireInfo ? this.getExpireTimeText() : '';
    const userAvatarId = `assignment-user-avatar-${personId}`;
    const userStatusId = `assignment-user-status-${personId}`;
    const personNameText = personName(person);
    const assignmentStatus = _.get(assignment, 'type_task_user_status', {});

    return (
      <div
        className={classnames(CLASS_NAME, 'style-guide', {
          '-with-expired-time': this.shouldRenderExpireAtInfo(),
        })}
        key={personId}
      >
        <div className={`${CLASS_NAME}__person`}>
          <div className={`${CLASS_NAME}__avatar-wrapper`} id={userAvatarId}>
            <Avatar
              className={`${CLASS_NAME}__avatar`}
              name={personNameText}
              person={person}
              size="xxsmall"
            />
          </div>
          <div className={`${CLASS_NAME}__username`}>{personNameText}</div>
          <div className={`${CLASS_NAME}__badge`} id={userStatusId}>
            <AssignmentBadge additionalText={expireTimeText} status={assignmentStatus} />
          </div>
          <UncontrolledTooltip
            className={`${CLASS_NAME}__tooltip`}
            placement="top"
            target={userAvatarId}
          >
            {personNameText}
          </UncontrolledTooltip>
          {shouldShowExpireInfo && (
            <UncontrolledTooltip
              className={`${CLASS_NAME}__tooltip`}
              placement="top"
              target={userStatusId}
            >
              {`Offer expires in ${expireTimeText}`}
            </UncontrolledTooltip>
          )}
        </div>

        {editMode && (
          <Buttons.TextButton
            className={`${CLASS_NAME}__remove`}
            onClick={this.removeAssignment(personId, person)}
            theme="link-subtle"
          >
            Remove
          </Buttons.TextButton>
        )}
      </div>
    );
  }
}

AssignmentPreviewRow.propTypes = {
  assignment: PropTypes.shape({
    expires_at: PropTypes.string,
    type_task_user_status: PropTypes.shape({
      code: PropTypes.string,
      status: PropTypes.string,
    }),
  }),
  editMode: PropTypes.bool,
  getPersonFromId: PropTypes.func,
  periodSetting: PropTypes.string,
  personId: PropTypes.number.isRequired,
  removePerson: PropTypes.func,
};

AssignmentPreviewRow.defaultProps = {
  periodSetting: PERIODS.HOURS,
};

const mapStateToProps = state => ({
  getPersonFromId: personId => datastore.selectors.company.getPerson(state, personId),
  periodSetting: datastore.selectors.company.getSetting(
    state,
    'user_accept_decline_expiration_period',
  ),
});

export default connect(mapStateToProps)(AssignmentPreviewRow);
